export default __webpack_public_path__ + "guide--raster-imagery-4up-480-c0306e875bebc8efa6662b69685f9dd5.webp";